import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  currentLanguage: string;
  messageFromQueryParams: string;

    constructor(private languageService: LanguageService, private translate: TranslateService, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.languageService.selectedLanguage$.subscribe((language: string) => {
      this.currentLanguage = language;
      this.translate.use(language);
    });

    this.messageFromQueryParams = this.activatedRoute.snapshot.queryParams['reason'];
  }

}
